<div #sidenavFeatured class="sideFeatured">
    <ng-container *ngIf="feedFeatureBlogs?.length">
      <p class="margin-0 font-bold width-100" [class.text-center]="horizaontalView">Featured from the desk of UNI</p>
      <ng-container *ngIf="horizaontalView; else verticalView">
        <div class="margin-top-5 overflow-x-scroll" fxLayout="row" fxLayoutGap="12px" #widgetsContent (wheel)="onWheel($event)">
          <ng-container *ngTemplateOutlet="defaultView">
          </ng-container>
        </div>
      </ng-container>
      
      <ng-template #verticalView>
        <div class="margin-top-5">
          <ng-container *ngTemplateOutlet="defaultView">
          </ng-container>
        </div>
      </ng-template>
      <ng-template #defaultView>
        <ng-container *ngFor="let feedBlog of feedFeatureBlogs">
          <uni-blog-card
            [blog]="feedBlog"
            [self]="self"
            [user]="user"
            [showCardOptions]="showCardOptions"
            [featured]="true"
            [isDisplay]="true">
          </uni-blog-card>
        </ng-container>
      </ng-template>
      <a [href]="goToJournalSearch()" target="_blank" class="margin-x-auto">
        <uni-navigation-button
          default="Explore More"
          button_class="secondary"
          icon_class = "icon-open-in-new-tab">
        </uni-navigation-button>
      </a>
    </ng-container>
</div>